import type { Error } from '@swf/core/utils/validators';

export const mustNotContainSymbols =
  (regexStr: RegExp, message?: Error['message']) =>
  (value: string): Error => ({
    valid: !regexStr.test(value),
    message
  });
